<template lang="pug">
  div.relative
    .fixed.z-50.inset-x-0.pointer-events-none
      div.container.mx-auto.p-4
        .flex.w-full.justify-between.items-center
          div.text-left
            a(@click='menu = true' ).pointer-events-auto.block.w-4
              div.flex.flex-col
                .border-b.border-black
                .my-1.border-b.border-black
                .border-b.border-black
          div.text-right
            a(@click='share = true').pointer-events-auto Share
      .absolute.inset-x-0.top-0.bg-acn-green(v-if='menu' v-click-outside='onClickOutsideMenu').p-4.pointer-events-auto
        .absolute.inset-x-0
          div.container.mx-auto.px-4.pt-1
            .flex.w-full.justify-between
              div.text-left
                a(@click='menu = false' ).pointer-events-auto.block.w-4
                  div.flex.flex-col.justify-center.items-center.text-white.text-5xl.leading-none.h-4
                    div &times;
        .flex.justify-center
          router-link( @click.native='menu = false' :to="{name:'home'}")
            logo(small).hover_text-white
        .flex.flex-col.justify-center.text-center.mt-4.text-white.font-extrabold
          router-link( @click.native='menu = false'  exact-active-class='underline' :to="{name:'home'}").hover_text-black.my-2 Home
          router-link( @click.native='menu = false'  exact-active-class='underline' :to="{name:'quotes'}").hover_text-black.mt-4 Quotes
          router-link( @click.native='menu = false'  exact-active-class='underline' :to="{name:'videos'}").hover_text-black.mb-4 Videos

          div( v-for="page of allPages" )
            router-link( @click.native='menu = false'  exact-active-class='underline' :to="{name: page.typeHandle, params:{ slug:page.slug }}").hover_text-black.my-2 {{page.title}}

      .absolute.w-full.top-0(v-if='share' )
        div.container.relative.mx-auto.p-4
          .absolute.top-0.right-0.pt-12.bg-acn-green(v-click-outside='onClickOutsideShare').pointer-events-auto
            .flex.justify-end
              .flex.justify-center.text-center.items-center
                a(@click="whatsapp('Check out Act Circular Now!')").p-2.hover_opacity-50.w-10
                  img(alt="Kraaijvanger Whatsapp" src="@/assets/whatsapp.svg")
                  //- img(alt="Kraaijvanger LinkedIn" src="@/assets/acn_share_linkedin.svg")
                a(@click="mail({subject:'Check out Act Circular Now!'})").p-2.hover_opacity-50.w-10
                  img(alt="Kraaijvanger Email" src="@/assets/mail.svg")
                a(@click="facebook()").p-2.hover_opacity-50.w-10
                  img(alt="Facebook" src="@/assets/facebook.svg")
                a(@click="twitter()").p-2.hover_opacity-50.w-10
                  img(alt="Twitter" src="@/assets/twitter.svg")
          .flex.w-full.justify-end.relative.text-white
            a(@click='share = false') Share
   
    div(:style="{'minHeight': `calc(100vh - ${footerHeight}px)`}").relative.z-10
      header.flex.w-full.justify-center.py-6.relative.z-20
        transition(name='fade' appear) 
          router-link(:to="{name:'home'}")
            logo.hover_text-acn-green-dark
      transition(name='fade' appear) 
        main(v-if='!initialLoading').relative.z-10          
          router-view
    footer(ref='footer').relative.z-20
      div(v-if='!initialLoading')
        transition(name='quick-fade-delay' mode='out-in')         
          div(v-show='!loading' key='ding')
            transition(name='fade' appear)         
                page-menu
              
            img(v-if='logoUrl' :src='logoUrl' alt='logo' v-in-viewport @load='checkFooterHeight').mx-auto.w-64.my-8

            .flex.justify-center.my-8.flex-wrap.items-center
              a(v-for='link of socialLinks' :href='link.socialUrl' target="_blank" v-in-viewport ).hover_opacity-50
                img(:src='link.image[0].url' :alt='link.display' @load='checkFooterHeight').w-12.m-4.hover_opacity-50
            div.pb-10
              .flex.justify-center.items-center
                //- hardcoded page/info
                router-link(  exact-active-class='underline text-acn-green-dark' :to="{name:'page', params:{ slug:'info' }}")
                  img(alt="Anbi" src="@/assets/anbi.png" @load='checkFooterHeight').w-16.ml-2
</template>

<script>
import share from '@/mixins/share'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'App',
  mixins: [share],
  data() {
    return {
      url: window.location.href,
      menu: false,
      share: false,
      initialLoading: null,
      footerHeight: null,
    }
  },
  computed: {
    ...mapGetters(['allPages']),
    ...mapState({
      loading: 'loading',
      globals: 'globals',
      socialLinks: (state) => {
        if (!state.socials.socialLinks) return []
        return state.socials.socialLinks
      },
      width: (state) => state.visual.window.width,
      height: (state) => state.visual.window.height,
    }),
    logoUrl() {
      if (
        this.$store.state.socials.logo &&
        this.$store.state.socials.logo.length
      ) {
        return this.$store.state.socials.logo[0].url
      }
      return null
    },
  },
  watch: {
    $route: {
      handler(newVal) {
        this.url = window.location.href
      },
      immediate: true,
    },
    width() {
      this.checkFooterHeight()
    },
    height() {
      this.checkFooterHeight()
    },
  },
  async created() {
    this.initialLoading = true
    await Promise.all([
      this.$store.dispatch('loadItems'),
      this.$store.dispatch('loadPages'),
      this.$store.dispatch('loadGlobals'),
      this.$store.dispatch('loadSocials'),
    ])
    this.initialLoading = false
    this.checkFooterHeight()
  },
  async mounted() {
    this.checkFooterHeight()
  },
  methods: {
    checkFooterHeight() {
      if (this.$refs.footer) this.footerHeight = this.$refs.footer.clientHeight
    },
    onClickOutsideShare() {
      this.share = false
    },
    onClickOutsideMenu() {
      this.menu = false
    },
  },
  metaInfo() {
    const title = `Act Circular Now`
    const description =
      'Circulaire en duurzame handvatten voor het beheeren van een (circulair) gebouw'
    const chunkFn = (chunk) => (!chunk ? title : `${chunk} | ${title}`)
    return {
      titleTemplate: chunkFn,
      meta: [
        {
          property: 'description',
          content: description,
          template: `%s | ${title}`,
          vmid: 'description',
        },
        {
          property: 'og:description',
          content: description,
          template: `%s | ${title}`,
          vmid: 'og:description',
        },
        {
          property: 'og:title',
          template: chunkFn,
          vmid: 'og:title',
        },
        { property: 'og:url', content: this.url },
        { property: 'og:type', content: 'website' },
        { property: 'og:image', content: this.logoUrl },
        { property: 'og:image:width', content: '300' },
        { property: 'og:site_name', content: title },
        { property: 'og:locale', content: 'nl_NL' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:url', content: this.url },
        {
          name: 'twitter:title',
          content: title,
          vmid: 'twitter:title',
        },
        {
          name: 'twitter:description',
          content: description,
          vmid: 'twitter:description',
        },
        { name: 'twitter:image', content: this.logoUrl },
      ],
    }
  },
}
</script>

<style lang="stylus">
@tailwind base;
@tailwind components;
@tailwind utilities;
a{
  cursor pointer
}
@font-face {
  font-family: 'Graphik';
  src: url('./assets/fonts/Graphik-300-Light.otf'); /* everyone else take this */
  font-weight: 300;
}
@font-face {
  font-family: 'Graphik';
  src: url('./assets/fonts/Graphik-400-Regular.otf'); /* everyone else take this */
  font-weight: 400;
}
@font-face {
  font-family: 'Graphik';
  src: url('./assets/fonts/Graphik-500-Medium.otf'); /* everyone else take this */
  font-weight: 500;
}
@font-face {
  font-family: 'Graphik';
  src: url('./assets/fonts/Graphik-700-Bold.otf'); /* everyone else take this */
  font-weight: 700;
}

body {
  font-family: 'Graphik', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  // min-height: 100%;
}
strong{
  font-weight: 500;
}

.redactor
  line-height 1.5
  a:hover
    color:#6AC27C
  p, img
    margin 1rem 0rem
  h1,h2,h3
    font-weight bold
    font-size 1.5rem
    margin 1.5rem 0rem
  img
    display inline-block

.below-viewport
  opacity:0;
  transform: translateY(100px);
  transition-duration: .75s;
.in-viewport
  opacity:1 ;
  transform: translateY(0%);
  transition-duration: .75s;


.fade-enter-active, .fade-leave-active {
  transition-property: all;
  transition-duration: 2s;
}

.fade-enter-active {
  transition-delay: .25s;
}
.fade-enter, .fade-leave-active {
  opacity: 0
}

.quick-fade-enter-active, .quick-fade-leave-active {
  transition-property: all;
  transition-duration: .5s;
}

.quick-fade-enter-active {
  // transition-delay: .25s;
}
.quick-fade-enter, .quick-fade-leave-active {
  opacity: 0
}

.quick-fade-delay-enter-active, .quick-fade-delay-leave-active {
  transition-property: all;
  // transition-delay:1s;
}


.quick-fade-delay-enter-active {
  transition-duration: .5s;
  transition-delay: 1s;
}
.quick-fade-delay-enter, .quick-fade-delay-leave-active {
  opacity: 0
}
</style>
